export var TableServerSubscriptTypeViewModel;
(function (TableServerSubscriptTypeViewModel) {
    TableServerSubscriptTypeViewModel["point"] = "point";
    TableServerSubscriptTypeViewModel["range"] = "range";
    TableServerSubscriptTypeViewModel["list"] = "list";
    TableServerSubscriptTypeViewModel["rangeStart"] = "start";
    TableServerSubscriptTypeViewModel["rangeEnd"] = "end";
})(TableServerSubscriptTypeViewModel || (TableServerSubscriptTypeViewModel = {}));
/* *** Platform specific indicator data *** */
export var GaussIndicatorTypeViewModel;
(function (GaussIndicatorTypeViewModel) {
    GaussIndicatorTypeViewModel["indicator"] = "indicator";
    GaussIndicatorTypeViewModel["function"] = "function";
})(GaussIndicatorTypeViewModel || (GaussIndicatorTypeViewModel = {}));
export var TableServerIndicatorTypeViewModel;
(function (TableServerIndicatorTypeViewModel) {
    TableServerIndicatorTypeViewModel["column"] = "column";
    TableServerIndicatorTypeViewModel["discriminatedColumn"] = "discriminated-column";
    TableServerIndicatorTypeViewModel["function"] = "function";
})(TableServerIndicatorTypeViewModel || (TableServerIndicatorTypeViewModel = {}));
export var TagTreeItemTypeViewModel;
(function (TagTreeItemTypeViewModel) {
    TagTreeItemTypeViewModel["tagGroup"] = "tagGroup";
    TagTreeItemTypeViewModel["indicator"] = "indicator";
})(TagTreeItemTypeViewModel || (TagTreeItemTypeViewModel = {}));
/* *** Related Utils *** */
export function isArgumentTypeString(arg) {
    if (!arg)
        return false;
    return typeof arg === 'string';
}
export function isArgumentTypeNumber(arg) {
    if (!arg)
        return false;
    return typeof arg === 'number';
}
export function isArgumentTypeTimeframe(arg) {
    if (!arg)
        return false;
    if (typeof arg !== 'object')
        return false;
    return 'start' in arg;
}
export function isArgumentTypeSlidingWindow(arg) {
    if (!arg)
        return false;
    if (typeof arg !== 'object')
        return false;
    return 'value' in arg;
}
export function isEnumeratedOptionAllowedArgument(argument) {
    return typeof argument === 'object' && argument !== null && 'input' in argument;
}
export function getAllowedArgumentValueViewModel(argument) {
    return isEnumeratedOptionAllowedArgument(argument) ? argument.input : argument.value;
}
export function isTimeframeAllowedArgument(argument) {
    const v = getAllowedArgumentValueViewModel(argument);
    return typeof v === 'object' && v !== null && 'start' in v;
}
export function isSlidingWindowAllowedArgument(argument) {
    return isArgumentTypeSlidingWindow(getAllowedArgumentValueViewModel(argument));
}
const ENVIRONMENT_DATA_KEY_BY_TARGET = {
    table: 'tableServerData',
    backtest: 'backtestData',
};
function hasAllowedArgumentEnvironmentData(arg) {
    if (typeof arg !== 'object' || arg === null)
        return false;
    return 'tableServerData' in arg || 'backtestData' in arg;
}
export function isAllowedArgumentAvailableForTarget(arg, target) {
    if (target === undefined)
        return true;
    if (!hasAllowedArgumentEnvironmentData(arg))
        return true;
    return arg[ENVIRONMENT_DATA_KEY_BY_TARGET[target]] !== undefined;
}
export function getAllowedArgumentTargetValueViewModel(arg, target) {
    const targetData = arg[ENVIRONMENT_DATA_KEY_BY_TARGET[target]];
    if (targetData?.value !== undefined)
        return targetData.value;
    return getAllowedArgumentValueViewModel(arg);
}
export function allowedValuesForTarget(values, target) {
    if (!values)
        return undefined;
    if (target === undefined)
        return [...values];
    return values.filter((arg) => isAllowedArgumentAvailableForTarget(arg, target));
}
//# sourceMappingURL=dictionary-view-model.js.map